import styles from "./complainthistory.module.css";
import dayjs from "dayjs";

const ComplaintHistory = ({ complaintData }) => {

    return (<>

        {complaintData?.histories && complaintData?.histories.map((itemHistory, indexH) => {
            return <div className={`${styles.BorderDivSumm}`} key={indexH}>
                <div className={`${styles.HistoryTitle}`}>
                    <img src="/static/img/RollCheck.svg" alt="" />
                    <p className={`${styles.HistoryTitleCon}`}>{itemHistory.title} <span>{dayjs(itemHistory.created_at).format("L")}</span></p>
                </div>
                <div className={`${styles.BorderDivSummHis}`}>
                    <p className={`${styles.SummCommBodyText}`} dangerouslySetInnerHTML={{ __html: itemHistory.description }}></p>
                </div>
            </div>
        })}

        {complaintData?.histories.length === 0 && <div className={`${styles.NoDataMain}`}>
            <div className={`${styles.NoDataIMG}`}>
                <img src="/static/img/nodata.svg" alt="No Data" />
            </div>
            <p className={`${styles.NoDataText}`}>No Data Found</p>
        </div>}
    </>);
}

export default ComplaintHistory;